import get from "lodash/get";
var getThemeValue = function(theme, path, fallback) {
    return String(get(theme, path, fallback));
};
export default getThemeValue;
